/**
 * The side navigation's adoption events, sent over HTTP (#15618).
 *
 * Fire-and-forget through the shell transport, for the reason
 * `org-nav-tracking.ts` gives: the sidebar is mounted in the root
 * layout and a row's click is simultaneous with its own navigation, so a
 * server action here would race the navigation it accompanies. `shellWrite`
 * swallows transport failures; an adoption event never affects navigation.
 */

import type { SideNavEventInput } from '@/lib/app-chrome/side-nav-event-input'
import { SHELL_ENDPOINTS, shellWrite } from '@/lib/shell-transport'

export function trackSideNavEvent(input: SideNavEventInput): void {
  void shellWrite(SHELL_ENDPOINTS.sideNavEvent, input)
}
